import {
  BooksIcon,
  CheckBox,
  DocumentIcon,
  FlipChartIcon,
  GlobeIcon,
  HeadPhonesIcon,
  ImageIcon,
  PlayIcon,
} from "@repo/edtech-assets";

import { LessonType } from "../../../../model";

export const ICON_BY_TYPE = {
  [ LessonType.Video ]: PlayIcon,
  [ LessonType.Scorm ]: GlobeIcon,
  [ LessonType.Test ]: CheckBox,
  [ LessonType.Pdf ]: DocumentIcon,
  [ LessonType.Presentation ]: FlipChartIcon,
  [ LessonType.Photo ]: ImageIcon,
  [ LessonType.Photo2 ]: ImageIcon,
  [ LessonType.Longread ]: BooksIcon,
  [ LessonType.Longread2 ]: BooksIcon,
  [ LessonType.Longread3 ]: BooksIcon,
  [ LessonType.Audio ]: HeadPhonesIcon,
  [ LessonType.Folder ]: DocumentIcon,
};
